import React from 'react';
import {Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';

import Modal from '../../../../shared/components//Modals/Modal.jsx';

class RemoveCdiModal extends Modal {
  static propTypes = {
    triggerCdiChange: PropTypes.func.isRequired,
    triggerPublicChange: PropTypes.func.isRequired
  }

  static defaultProps = {
    triggerPublicChange: () => {},
    triggerCdiChange: () => {}
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  cancel = () => {
    this.props.triggerPublicChange(false);
    this.props.closeModal();
  };

  confirm = () => {
    this.props.triggerCdiChange(false);
    this.props.closeModal();
  };

  render() {
    const modalProps = {};

    if (!this.state.loading) {
      modalProps.toggle = this.close;
    }

    return (
      <BootstrapModal toggle={this.cancel} isOpen={this.props.isOpen}>
        <ModalHeader toggle={this.cancel}>Passer le profil en public</ModalHeader>
        <ModalBody>
          <div className="text-center mb-4">
            Voulez-vous retirer l'attribut CDI ?
          </div>
          <div className="d-flex justify-content-around">
            <button onClick={this.confirm} type="button" className="btn btn-secondary">Valider</button>
            <button onClick={this.cancel} type="button" className="btn btn-primary">Annuler</button>
          </div>
        </ModalBody>
      </BootstrapModal>
    );
  }
}

export default withRouter(RemoveCdiModal);
